import { createSelector } from 'reselect';

const getEnterpriseSingleFamily = state => state.enterpriseSingleFamily;

const EnterpriseSingleFamilySelectors = {
    makeContracts: createSelector([getEnterpriseSingleFamily],
        enterpriseSingleFamily => enterpriseSingleFamily.contracts),
};

export default EnterpriseSingleFamilySelectors;
